import * as React from 'react';

import Button from '@mui/material/Button';
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker';
import { TextField } from '@mui/material';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { useFormik } from 'formik';
import { listLicenseLinks } from '../../services/service';
import { FormDialog } from '../../components/FormDialog';
import dateFnsFormat from 'date-fns/format';
import TodayIcon from '@mui/icons-material/Today';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';

export default function LicenseLinkFilter(props) {
  const {
    pageSize,
    loading,
    setLicenseLinksData,
    setLoading,
    setFilters
  } = props;
  const [open, setOpen] = React.useState(false);
  const [initialDatetime, setInitialDatetime] = React.useState(null);
  const [finalDatetime, setFinalDatetime] = React.useState(null);
  const [filtersState, setFiltersState] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const callListLicenses = (filters) => {
    listLicenseLinks(1, pageSize, filters).then((response) => {
      response.data.results.map((value) => {
        value['created_at'] = dateFnsFormat(new Date(value.created_at), 'dd/MM/yy HH:mm')
        value["hardware"] = !!value.hardware.name ? value.hardware.name : value.hardware
        value["license_type"] = !!value.license.license_type ? value.license.license_type.name : "N/A"
        value["license"] = !!value.license.id ? value.license.id : value.license
        return value
      })
      setLicenseLinksData(response.data)
      handleClose()
    }).finally((resp) => {
      setLoading(false)
    })
  }

  const formik = useFormik({
    initialValues: {
      description: "",
      hardware_key: "",
      company: "",
      license_type_slug: "",
    },
    // validationSchema: validationSchema,
    onSubmit: (values) => {
      var filters = {
        created_at__gte: initialDatetime === null ? '' : initialDatetime.toISOString(),
        created_at__lte: finalDatetime === null ? '' : finalDatetime.toISOString(),
        license_type_slug: formik.values.license_type_slug
      }
      filters["expand"] = "license_type,company"
      setFilters(filters)
      callListLicenses(filters)
      setFiltersState(true)
    },
  })

  const clearFilter = () => {
    var filters = {
      expand: 'license_type,company'
    }
    setFilters(filters)
    callListLicenses(filters)
    setFiltersState(false)
    formik.resetForm()
    setInitialDatetime(null)
    setFinalDatetime(null)
  }


  return (
    <div>
      <Row>
        <Col sm={1}>
          <Button variant="outlined" onClick={handleClickOpen}>
            Filtrar
          </Button>
        </Col>
        {
          filtersState
            ? (
              <Col sm={2}>
                <Button variant="outlined" color="error" onClick={clearFilter} type='submit' >
                  Limpar Filtro
                </Button>
              </Col>
            )
            : null
        }
      </Row>
      <FormDialog
        title={"Selecione os filtros desejados"}
        open={open}
        onDismiss={handleClose}
        formWidth={350}
        loading={loading}
        onSubmit={formik.handleSubmit}
      >
        <form onSubmit={formik.handleSubmit}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDateTimePicker
              label={<div><span> Data inicial</span> <TodayIcon style={{ marginLeft: '10rem' }} /></div>}
              ampm={false}
              inputFormat="dd/MM/yy HH:mm"
              name="created_at__gte"
              value={initialDatetime}
              onChange={(value) => {
                setInitialDatetime(value);
              }}
              renderInput={(params) => <TextField {...params} variant="standard" />}
            />
            <MobileDateTimePicker
              label={<div> <span> Data final</span><TodayIcon style={{ marginLeft: '11rem' }} /> </div>}
              ampm={false}
              inputFormat="dd/MM/yy HH:mm"
              name="created_at__lte"
              value={finalDatetime}
              onChange={(value) => {
                setFinalDatetime(value);
              }}
              renderInput={(params) => <TextField {...params} variant="standard" />}
            />
          </LocalizationProvider>
          {/* <APISelectField
            id="license-type-slug"
            label="Slug do Modelo de Licença"
            name="license_type_slug"
            multiline
            disabled={loading}
            value={formik.values.license_type_slug}
            onChange={formik.handleChange}
            variant="outlined"
            style={{ width: "18rem", margin: '1rem 0rem' }}
          >
            <MenuItem value=''>{'Todas licenças'}</MenuItem>
            {modelLicense.map(company => (
              <MenuItem key={company.slug_name} value={company.slug_name}>{company.name}</MenuItem>
            ))}
          </APISelectField> */}
        </form>
      </FormDialog>
      {/* </Dialog> */}
    </div>
  );
}